export default __webpack_public_path__ + "static/media/Belgard_LafittGranaSlab_TITANIUM.642dc80a.jpg";